/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { Flag } from 'ui/atoms/Flag/Flag';

import styles from './TechnologyRegistries.module.scss';

type Registry = {
  name: string;
  code: string;
};

const REGISTRIES: Registry[] = [
  { name: 'Companies House', code: 'gb' },
  { name: 'KVK', code: 'nl' },
  { name: 'Handelsregister', code: 'de' },
  { name: 'SEC EDGAR', code: 'us' },
  { name: 'RCS', code: 'lu' },
  { name: 'INPI', code: 'fr' },
  { name: 'Registro Mercantil', code: 'es' },
  { name: 'Registro Imprese', code: 'it' },
  { name: 'Corporations Canada', code: 'ca' },
  { name: 'Bolagsverket', code: 'se' },
  { name: 'Brønnøysund', code: 'no' },
  { name: 'CVR', code: 'dk' },
  { name: 'ASIC', code: 'au' },
  { name: 'Firmenbuch', code: 'at' },
  { name: 'Zefix', code: 'ch' },
  { name: 'ACRA', code: 'sg' },
  { name: 'MCA', code: 'in' },
  { name: 'CIPC', code: 'za' },
  { name: 'Junta Comercial', code: 'br' },
  { name: 'NZBN', code: 'nz' },
];

const TRACK = [...REGISTRIES, ...REGISTRIES];

export const TechnologyRegistries = () => {
  const { t } = useInt();

  return (
    <section className={styles.root} aria-label={t('Source registries')}>
      <div className={styles.caption}>
        <span className={styles.led} />
        {t('sources — read directly, no reseller in the middle')}
      </div>

      <div className={styles.marquee}>
        <div className={styles.track}>
          {TRACK.map((registry, i) => (
            <div className={styles.item} key={`${registry.code}-${i}`}>
              <Flag code={registry.code} className={styles.flag} />
              <span className={styles.itemBody}>
                <b>{registry.name}</b>
                <span className={styles.code}>{registry.code.toUpperCase()}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
